export var ModalStep;
(function (ModalStep) {
    ModalStep["AUTH_MAIN"] = "AUTH_MAIN";
    ModalStep["AUTH_MORE"] = "AUTH_MORE";
    ModalStep["EX_WALLET_MORE"] = "EX_WALLET_MORE";
    ModalStep["EX_WALLET_SELECTED"] = "EX_WALLET_SELECTED";
    ModalStep["VERIFICATIONS"] = "VERIFICATIONS";
    ModalStep["AWAITING_OAUTH"] = "AWAITING_OAUTH";
    ModalStep["FARCASTER_OAUTH"] = "FARCASTER_OAUTH";
    ModalStep["BIOMETRIC_CREATION"] = "BIOMETRIC_CREATION";
    ModalStep["AWAITING_BIOMETRIC_CREATION"] = "AWAITING_BIOMETRIC_CREATION";
    ModalStep["AWAITING_WALLET_CREATION"] = "AWAITING_WALLET_CREATION";
    ModalStep["WALLET_CREATION_DONE"] = "WALLET_CREATION_DONE";
    ModalStep["SECRET"] = "SECRET";
    ModalStep["BIOMETRIC_LOGIN"] = "BIOMETRIC_LOGIN";
    ModalStep["AWAITING_BIOMETRIC_LOGIN"] = "AWAITING_BIOMETRIC_LOGIN";
    ModalStep["LOGIN_DONE"] = "LOGIN_DONE";
    ModalStep["SETUP_2FA"] = "SETUP_2FA";
    ModalStep["VERIFY_2FA"] = "VERIFY_2FA";
    ModalStep["TWO_FACTOR_DONE"] = "TWO_FACTOR_DONE";
    ModalStep["ADD_FUNDS"] = "ADD_FUNDS";
    ModalStep["ADD_FUNDS_AWAITING"] = "ADD_FUNDS_AWAITING";
    ModalStep["ADD_FUNDS_SUCCESS"] = "ADD_FUNDS_SUCCESS";
    ModalStep["ADD_FUNDS_FAILURE"] = "ADD_FUNDS_FAILURE";
    ModalStep["ACCOUNT_MAIN"] = "ACCOUNT_MAIN";
    ModalStep["CHAIN_SWITCH"] = "CHAIN_SWITCH";
})(ModalStep || (ModalStep = {}));
var AccountStep;
(function (AccountStep) {
    AccountStep["ACCOUNT_MAIN"] = "ACCOUNT_MAIN";
    AccountStep["ADD_FUNDS"] = "ADD_FUNDS";
    AccountStep["ADD_FUNDS_AWAITING"] = "ADD_FUNDS_AWAITING";
    AccountStep["ADD_FUNDS_SUCCESS"] = "ADD_FUNDS_SUCCESS";
    AccountStep["ADD_FUNDS_FAILURE"] = "ADD_FUNDS_FAILURE";
    AccountStep["CHAIN_SWITCH"] = "CHAIN_SWITCH";
})(AccountStep || (AccountStep = {}));
export const AccountPreviousStep = {
    [AccountStep.ACCOUNT_MAIN]: undefined,
    [AccountStep.ADD_FUNDS]: ModalStep.ACCOUNT_MAIN,
    [AccountStep.ADD_FUNDS_AWAITING]: ModalStep.ADD_FUNDS,
    [AccountStep.ADD_FUNDS_SUCCESS]: ModalStep.ACCOUNT_MAIN,
    [AccountStep.ADD_FUNDS_FAILURE]: ModalStep.ACCOUNT_MAIN,
    [AccountStep.CHAIN_SWITCH]: ModalStep.ACCOUNT_MAIN,
};
var SignUpModalStep;
(function (SignUpModalStep) {
    SignUpModalStep["AUTH_MAIN"] = "AUTH_MAIN";
    SignUpModalStep["AUTH_MORE"] = "AUTH_MORE";
    SignUpModalStep["EX_WALLET_MORE"] = "EX_WALLET_MORE";
    SignUpModalStep["EX_WALLET_SELECTED"] = "EX_WALLET_SELECTED";
    SignUpModalStep["VERIFICATIONS"] = "VERIFICATIONS";
    SignUpModalStep["AWAITING_OAUTH"] = "AWAITING_OAUTH";
    SignUpModalStep["FARCASTER_OAUTH"] = "FARCASTER_OAUTH";
    SignUpModalStep["BIOMETRIC_CREATION"] = "BIOMETRIC_CREATION";
    SignUpModalStep["AWAITING_BIOMETRIC_CREATION"] = "AWAITING_BIOMETRIC_CREATION";
    SignUpModalStep["AWAITING_WALLET_CREATION"] = "AWAITING_WALLET_CREATION";
    SignUpModalStep["WALLET_CREATION_DONE"] = "WALLET_CREATION_DONE";
    SignUpModalStep["SECRET"] = "SECRET";
    SignUpModalStep["SETUP_2FA"] = "SETUP_2FA";
    SignUpModalStep["VERIFY_2FA"] = "VERIFY_2FA";
    SignUpModalStep["TWO_FACTOR_DONE"] = "TWO_FACTOR_DONE";
    SignUpModalStep["ADD_FUNDS"] = "ADD_FUNDS";
    SignUpModalStep["ADD_FUNDS_AWAITING"] = "ADD_FUNDS_AWAITING";
    SignUpModalStep["ADD_FUNDS_SUCCESS"] = "ADD_FUNDS_SUCCESS";
    SignUpModalStep["ADD_FUNDS_FAILURE"] = "ADD_FUNDS_FAILURE";
})(SignUpModalStep || (SignUpModalStep = {}));
export const SignUpPreviousStep = {
    [SignUpModalStep.AUTH_MAIN]: undefined,
    [SignUpModalStep.AUTH_MORE]: ModalStep.AUTH_MAIN,
    [SignUpModalStep.EX_WALLET_MORE]: ModalStep.AUTH_MAIN,
    [SignUpModalStep.EX_WALLET_SELECTED]: ModalStep.AUTH_MAIN,
    [SignUpModalStep.VERIFICATIONS]: ModalStep.AUTH_MAIN,
    [SignUpModalStep.AWAITING_OAUTH]: ModalStep.AUTH_MAIN,
    [SignUpModalStep.FARCASTER_OAUTH]: ModalStep.AUTH_MAIN,
    [SignUpModalStep.BIOMETRIC_CREATION]: ModalStep.AUTH_MAIN,
    [SignUpModalStep.AWAITING_BIOMETRIC_CREATION]: ModalStep.BIOMETRIC_CREATION,
    [SignUpModalStep.AWAITING_WALLET_CREATION]: undefined,
    [SignUpModalStep.WALLET_CREATION_DONE]: undefined,
    [SignUpModalStep.SECRET]: undefined,
    [SignUpModalStep.SETUP_2FA]: ModalStep.SECRET,
    [SignUpModalStep.VERIFY_2FA]: ModalStep.SETUP_2FA,
    [SignUpModalStep.TWO_FACTOR_DONE]: undefined,
    [SignUpModalStep.ADD_FUNDS]: undefined,
    [SignUpModalStep.ADD_FUNDS_AWAITING]: ModalStep.ADD_FUNDS,
    [SignUpModalStep.ADD_FUNDS_SUCCESS]: undefined,
    [SignUpModalStep.ADD_FUNDS_FAILURE]: undefined,
};
var LoginModalStep;
(function (LoginModalStep) {
    LoginModalStep["AUTH_MAIN"] = "AUTH_MAIN";
    LoginModalStep["AUTH_MORE"] = "AUTH_MORE";
    LoginModalStep["EX_WALLET_MORE"] = "EX_WALLET_MORE";
    LoginModalStep["EX_WALLET_SELECTED"] = "EX_WALLET_SELECTED";
    LoginModalStep["AWAITING_OAUTH"] = "AWAITING_OAUTH";
    LoginModalStep["FARCASTER_OAUTH"] = "FARCASTER_OAUTH";
    LoginModalStep["BIOMETRIC_LOGIN"] = "BIOMETRIC_LOGIN";
    LoginModalStep["AWAITING_BIOMETRIC_LOGIN"] = "AWAITING_BIOMETRIC_LOGIN";
    LoginModalStep["AWAITING_WALLET_CREATION"] = "AWAITING_WALLET_CREATION";
    LoginModalStep["WALLET_CREATION_DONE"] = "WALLET_CREATION_DONE";
    LoginModalStep["SECRET"] = "SECRET";
    LoginModalStep["SETUP_2FA"] = "SETUP_2FA";
    LoginModalStep["VERIFY_2FA"] = "VERIFY_2FA";
    LoginModalStep["TWO_FACTOR_DONE"] = "TWO_FACTOR_DONE";
    LoginModalStep["LOGIN_DONE"] = "LOGIN_DONE";
    LoginModalStep["ADD_FUNDS"] = "ADD_FUNDS";
    LoginModalStep["ADD_FUNDS_AWAITING"] = "ADD_FUNDS_AWAITING";
    LoginModalStep["ADD_FUNDS_SUCCESS"] = "ADD_FUNDS_SUCCESS";
    LoginModalStep["ADD_FUNDS_FAILURE"] = "ADD_FUNDS_FAILURE";
})(LoginModalStep || (LoginModalStep = {}));
export const LoginPreviousStep = {
    [LoginModalStep.AUTH_MAIN]: undefined,
    [LoginModalStep.AUTH_MORE]: ModalStep.AUTH_MAIN,
    [SignUpModalStep.EX_WALLET_MORE]: ModalStep.AUTH_MAIN,
    [SignUpModalStep.EX_WALLET_SELECTED]: ModalStep.AUTH_MAIN,
    [LoginModalStep.AWAITING_OAUTH]: ModalStep.AUTH_MAIN,
    [LoginModalStep.FARCASTER_OAUTH]: ModalStep.AUTH_MAIN,
    [LoginModalStep.BIOMETRIC_LOGIN]: ModalStep.AUTH_MAIN,
    [LoginModalStep.AWAITING_BIOMETRIC_LOGIN]: ModalStep.BIOMETRIC_LOGIN,
    [LoginModalStep.AWAITING_WALLET_CREATION]: undefined,
    [LoginModalStep.WALLET_CREATION_DONE]: undefined,
    [LoginModalStep.SECRET]: undefined,
    [LoginModalStep.SETUP_2FA]: undefined,
    [LoginModalStep.VERIFY_2FA]: ModalStep.SETUP_2FA,
    [LoginModalStep.TWO_FACTOR_DONE]: undefined,
    [LoginModalStep.LOGIN_DONE]: undefined,
    [LoginModalStep.ADD_FUNDS]: ModalStep.LOGIN_DONE,
    [LoginModalStep.ADD_FUNDS_AWAITING]: ModalStep.ADD_FUNDS,
    [LoginModalStep.ADD_FUNDS_SUCCESS]: undefined,
    [LoginModalStep.ADD_FUNDS_FAILURE]: undefined,
};
